module.exports = __webpack_public_path__ + "img/bg_radio@3x.d56320c2.png";